/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2020
 * @format
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import FireboardUtils from '../../../../../util/fireboard-util';
import CheckCard from './CheckCard';
import ChecksWithGroup from './ChecksWithGroup';
import styles from './TablesList.module.css';

const TablesList = (props) => {
  const { checks, selectedCheck, onSelectCheck, checkFilters, sensorsMap, managerMode, currency, fbVenueMode } = props;
  const deviceApi = useSelector(state => state?.deviceApi?.data);
  const deviceApiData = useSelector(state => state?.deviceApiData);
  const { groupedView } = useSelector(state => state?.checkSortReducer?.data);
  const { deviceGroup } = deviceApi || deviceApiData || {};
  const deviceGroupIsNotNull = !FireboardUtils.isObjectBlank(deviceGroup);
  const isGroupingAllow = deviceGroupIsNotNull ? deviceGroup?.fireBoardSettings?.groupedView : groupedView;

  const renderItem = (table, rowIndex) => {
    return (
      <CheckCard
        rowIndex={rowIndex}
        key={`table-${table.id}`}
        check={table}
        isSelected={table?.id === selectedCheck?.id}
        onSelectCheck={onSelectCheck}
        managerMode={managerMode}
        currency={currency}
        fbVenueMode={fbVenueMode}
      />
    );
  };

  return (
    isGroupingAllow
      ? (
        <ChecksWithGroup
          checks={checks}
          selectedCheck={selectedCheck}
          onSelectCheck={onSelectCheck}
          checkFilters={checkFilters}
          sensorsMap={sensorsMap}
          managerMode={managerMode}
          currency={currency}
          fbVenueMode={fbVenueMode}
        />
      ) : (
        (checks && Array.isArray(checks) && checks.length) ? (
          <div className={styles.container}>
            {checks.map((table, rowIndex) => renderItem(table, rowIndex))}
          </div>
        ) : (
          <NoChecks />
        )
      )
  );
};

export default TablesList;

const NoChecks = () => {
  return (
    <div className={styles.noChecks}>No Checks</div>
  )
};
